<button class="btn {{btnCssClass}}" (click)="triggerEvent()" [innerHTML]="btnInnerHtml"></button>